function AdminTypos(props) {
    return <div className="admin-typos" style={props.style}>
        <div className="primary">{props?.primary}</div>
        <div className="secondary">{props?.secondary}</div>
    </div>
}

export default AdminTypos